// extracted by mini-css-extract-plugin
export var blockBtn = "courseInvitation-module--block-btn--2e1e5";
export var courseInvitation = "courseInvitation-module--course-invitation--db06f";
export var courseInvitation__confetti = "courseInvitation-module--course-invitation__confetti--08215";
export var courseInvitation__title = "courseInvitation-module--course-invitation__title--14eee";
export var courseInvitation__wrapper = "courseInvitation-module--course-invitation__wrapper--39029";
export var mainBtn = "courseInvitation-module--main-btn--a5d87";
export var mainTitle = "courseInvitation-module--main-title--2d529";
export var title = "courseInvitation-module--title--496ac";